/* eslint-disable no-unused-vars */
import babelpolyfill from 'babel-polyfill';
/* eslint-enable no-unused-vars */
import './assets/css/bulma.css';
import Vue from 'vue';
import NProgress from 'vue-nprogress';
import Router from 'vue-router';
import VueI18n from 'vue-i18n';
import App from './App';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css';
import routerMap from './router/index';
import lang from './lang/lang.js';
import 'font-awesome/css/font-awesome.min.css';
import ApiDomain from './core/ApiDomain';
import ewxLoginSDK from '@qtt/ewx-login-sdk';
import store from '@/store';

Vue.use(ElementUI);
Vue.use(Router);
Vue.use(VueI18n);
Vue.use(NProgress);

const nprogress = new NProgress({
    parent: '.nprogress-container'
});

const i18n = new VueI18n({
    locale: 'zn', // set locale
    messages: lang // set locale messages
});

const router = new Router(routerMap);

router.beforeEach((to, from, next) => {
    // 测试接口切换功能
    ApiDomain.setApiBranch(to.query);
    if (to.fullPath === '/login' || from.fullPath === '/login') {
        next();
    } else {
        ewxLoginSDK.getUserInfo({ isPerm: true }).then(res => {
            if (!res) {
                next('/login');
            } else {
                next();
            }
        });
    }
});

Vue.mixin({
    created () {
        if (this.filter) {
            this.filter = this.$queryFilter();
            this.$updateRouter(this.filter);
        }
    },
    methods: {
        $queryFilter () {
            let filter = this.filter || {};
            if (this.$route) {
                let query = this.$route.query;
                for (let i in filter) {
                    if (typeof query[i] !== 'undefined') {
                        if (typeof filter[i] === 'number') {
                            filter[i] = parseInt(query[i]);
                        } else {
                            filter[i] = query[i];
                        }
                    }
                }
            }
            return filter;
        },
        $updateRouter (query) {
            if (!query) {
                query = this.$queryFilter();
            }
            this.$router.replace({
                query: Object.assign({}, query)
            });
        },
        $blockRequest ({ $elem, req, pendingText = '操作中' }) {
            if (!$elem) {
                $elem = document.createElement('button');
            }
            if (!$elem || $elem._req_block) return;

            let isButton = $elem.nodeName.toLowerCase() === 'button';
            let oText = $elem.innerText;

            if (isButton) $elem.setAttribute('disabled', true);

            $elem.innerText = pendingText;
            $elem._req_block = true;

            return req.fin(() => {
                if (isButton) $elem.removeAttribute('disabled');
                $elem._req_block = false;
                $elem.innerText = oText;
            });
        }
    }
});

new Vue({
    router,
    store,
    i18n,
    nprogress,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js